import {
    GET_PEOPLE,
    GET_EVENT_PAGE_DATA,
    CLEAR_EVENT_PAGE_DATA
} from "../actiontypes";

//! Composed URL For API
import ApiPath from "../utils/Apis/ApiPath";
import history from "../utils/Routing/history";

import { MEETING_TYPES_INTS } from "../utils/Generic/meetingTypes";

//! EVENT PAGE REDUCER ACTION CREATORS
// Gets Event Data
export const getEventPageData = eventId => async (dispatch, getState) => {
    const { sessionId, companyId } = getState().user.user;

    const response = await fetch(
        `${ApiPath.urlApi}/api/events/getEventDetails?db=${ApiPath.db}&event_id=${eventId}&type=json&SessionId=${sessionId}&CompId=${companyId}`
    );
    const responseParsed = await response.json();

    dispatch({ type: GET_EVENT_PAGE_DATA, payload: responseParsed });
};

// Clears Event Page Data
export const clearEventPageData = () => {
    return {
        type: CLEAR_EVENT_PAGE_DATA
    };
};

// Gets List Of People Based On Event
// eslint-disable-next-line no-unused-vars
export const getEventAttendees =
    (eventId, meetingType) => async (dispatch, getState) => {
        const { sessionId, companyId } = getState().user.user;

        const baseURL = `${ApiPath.urlApi}/api/eventAttendees/getAttendees?`;
        const response = await fetch(
            `${baseURL}db=${ApiPath.db}&event_id=${eventId}&meetingTypeId=${MEETING_TYPES_INTS[meetingType]}&type=json&SessionId=${sessionId}&CompId=${companyId}`
        );

        const responseParsed = await response.json();

        // Dispatch = Async
        dispatch({ type: GET_PEOPLE, payload: responseParsed });

        history.push("/peopleSearch");
    };
